<template>
<kt-row v-if="status === 'setFormData'">
    <kt-col xs="12">
        <form @submit.prevent="edit" id="settings_form">
            <kt-form-group>
                <kt-form-label>
                    {{ $t('label.change_status') }}
                </kt-form-label>
                <kt-form-select
                        size="3"
                        id="status"
                        name="status"
                        v-model="payman.status"
                >
                    <option
                            v-bind:key="index"
                            v-for="(status, index) in statuses"
                            v-bind:value="status.value"
                            :selected="payman.status === status.value"
                    >
                        {{ status.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>

            <kt-form-group>
                <kt-form-label>
                    {{ $t('label.change_wage_type') }}
                </kt-form-label>
                <kt-form-select size="3" id="wage_type" name="wage_type" v-model="payman.wage_type">
                    <option
                            v-bind:key="index"
                            v-for="(wage_type, index) in wage_types"
                            v-bind:value="wage_type.value"
                            :selected="wage_type.value"
                    >
                        {{ wage_type.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>

            <transition name="fade">
                <kt-form-group v-if="payman.wage_type == 1">
                    <kt-form-label>
                        {{ $t('label.change_wage_period') }}
                    </kt-form-label>
                    <kt-form-select
                            size="4"
                            id="wage_periodic_type"
                            name="wage_periodic_type"
                            v-model="payman.wage_periodic_type"
                    >
                        <option
                                v-bind:key="index"
                                v-for="(wage_periodic_type, index) in wage_periodic_types"
                                v-bind:value="wage_periodic_type.value"
                                :selected="wage_periodic_type.value"
                        >
                            {{ wage_periodic_type.name }}
                        </option>
                    </kt-form-select>
                </kt-form-group>
            </transition>
            <transition name="fade">
                <kt-form-group>
                    <kt-form-label>
                        {{
                        (payman.wage_type == 3) ?
                        $t('label.wage_amount_percent') :
                        ((payman.wage_type == 2) ?
                        $t('label.wage_amount_fixed') :
                        $t('label.wage_amount_periodic'))
                        }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <kt-form-control dir="ltr" id="wage_amount" name="wage_amount" v-model="payman.wage_amount">
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{
                                (payman.wage_type == 3) ?
                                $t('label.percent'):
                                $t('currency.rial')
                                }}</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>
            <transition name="fade">
                <kt-form-group v-if="payman.wage_type == 3">
                    <kt-form-label>
                        {{ $t('label.max_wage_amount') }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <kt-form-control dir="ltr" id="wage_max_wage" name="wage_max_wage" v-model="payman.wage_max_wage">
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{ $t('currency.rial') }}</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>

            <kt-form-action class="mt-4">
                <button class="btn btn-md btn-success btn-wide" type="submit" id="change_status_btn">
                    {{ $t('btn.edit') }}
                </button>
            </kt-form-action>
        </form>
    </kt-col>
</kt-row>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { paymanStatusStr, paymanStatus } from '@/constants/paymanStatus'
import { mapGetters } from 'vuex'
import { paymanService } from '@/common/api.service'
import { i18n } from '@/plugins/i18n'

export default {
    computed: {
        ...mapGetters('payman', {
            payman: 'form_data',
            status: 'status'
        }),
    },
    data() {
        return {
            statuses: [
                {
                    name: paymanStatusStr.ACTIVE,
                    value: paymanStatus.ACTIVE
                },
                {
                    name: paymanStatusStr.PENDING,
                    value: paymanStatus.PENDING
                },
                {
                    name: paymanStatusStr.REJECTED,
                    value: paymanStatus.REJECTED
                },
                {
                    name: paymanStatusStr.BLOCKED,
                    value: paymanStatus.BLOCKED
                },
            ],
            wage_types: [
                {
                    name: this.$t('gateway.wage_types.percent'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_types.fixed'),
                    value: 2
                },
                {
                    name: this.$t('gateway.wage_types.periodic'),
                    value: 1,
                }
            ],
            wage_periodic_types: [
                {
                    name: this.$t('gateway.wage_periodic_types.1'),
                    value: 1
                },
                {
                    name: this.$t('gateway.wage_periodic_types.3'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_periodic_types.6'),
                    value: 6,
                },
                {
                    name: this.$t('gateway.wage_periodic_types.12'),
                    value: 12,
                }
            ]
        }
    },
    methods: {
        edit(e) {
            let btn = $('#change_status_btn')
            let form = $('#settings_form')
            KTApp.progress(btn)

            let is_failed = false
            paymanService.changeStatus(this.payman.id, this.payman.status)
                .then(this.$store.dispatch('badgeCounter/countData'))
                .catch(({response}) => {
                    is_failed = true
                })

            paymanService.changeWage(this.payman.id, {
                wage_type: this.payman.wage_type,
                wage_periodic_type: this.payman.wage_periodic_type,
                wage_amount: this.payman.wage_amount,
                wage_max_wage: this.payman.wage_max_wage,
            })
                .catch(({response}) => {
                    is_failed = true
                })
                .finally(
                    response => {
                        KTApp.unprogress(btn)
                    }
                )

            if (is_failed) {
                this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
            } else {
                this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))
            }
        }
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>